
<template>
  <div class="row wrapper border-bottom white-bg page-heading mb-2">
    <div class="d-flex align-self-center justify-content-between">
      <h2 class="mt-0">{{ $t("navigations.data signals") }}</h2>
    </div>
  </div>

  <div class="ibox-content">
    <div class="mb-2">
      <div class="form-group row mb-1">
        <div
          class="d-flex flex-column flex-lg-row justify-content-lg-start my-2 my-lg-0"
        >
          <!-- <div class="col-12 col-md-2 my-1 my-lg-0 pl-lg-0 pr-lg-1">
              <div class="form-group mb-0">
                <label class="mb-0">{{ $t("navigations.signalId") }}</label>
                <input type="text" class="form-control" v-model="signalId" id="signalId" />
              </div>
            </div> -->
          <div class="col-12 col-md-10 my-1 my-lg-0 pl-lg-0 pr-lg-1">
            <div class="form-group mb-0">
              <label class="mb-0">{{ $t("navigations.site code") }}</label>
              <input
                type="text"
                class="form-control"
                v-model="siteCode"
                id="siteCode"
              />
            </div>
          </div>
          <!-- <div class="col-12 col-md-2 my-1 my-lg-0 pl-lg-0 pr-lg-1">
              <div class="form-group mb-0">
                <label class="mb-0">{{ $t("navigations.outcome") }}</label>
                <select class="form-control" v-model="outcome">
                   <option value="" default selected>
                                        {{ $t("navigations.select") }}
                                    </option>
                  <option value="High variability">High variability</option>
                  <option value="Low variability">Low variability</option>
                  <option value="Zero variability">Zero variability</option>
                </select>
              </div>
            </div> -->
          <!-- <div class="col-12 col-md-2 my-1 my-lg-0 pl-lg-0 pr-lg-1">
              <div class="form-group mb-0">
                <label class="mb-0">{{ $t("navigations.sdv required") }}</label>
                <select class="form-control" v-model="isSDV">
                   <option value="" default selected>
                                        {{ $t("navigations.select") }}
                                    </option>
                  <option value="true">Yes</option>
                  <option value="false">No</option>
                </select>
              </div>
            </div> -->
          <!-- <div class="col-12 col-md-4 my-1 my-lg-0 pl-lg-0 pr-lg-1">
                <div class="form-group mb-0">
                <label class="mb-0">{{ $t("navigations.riskindicator") }}</label>
                <input type="text" class="form-control" v-model="riskName" id="version" />
                </div>
            </div> -->
          <!-- <div class="col-12 col-md-3 my-1 my-lg-0 pl-lg-0 pr-lg-1">
                <div class="form-group mb-0">
                <label class="mb-0">{{ $t("navigations.status") }}</label>
                <input type="text" class="form-control" v-model="status" id="version" />
                </div>
            </div> -->
          <div
            class="col-12 col-md-2 save_btn w-100 align-self-end"
            type="button"
            @click.prevent="getSearchData()"
          >
            {{ $t("navigations.search") }}
          </div>
        </div>
      </div>
    </div>
    <div class="ibox-content data-grid-container px-1">
      <div class="d-flex justify-content-end align-items-center mb-2">
        <div
          class="position-relative cursor-pointer mr-2"
          v-if="criticalDataPoints.length != 0"
          @click.prevent="showFilter = !showFilter"
        >
          <img
            src="../../assets/img/filter.png"
            width="17"
            height="17"
            alt="filter table"
          />
          <div class="tool-tip">{{ $t("navigations.filter") }}</div>
        </div>
      </div>
      <div class="d-flex justify-content-end px-0 mb-2" v-if="showFilter">
        <div class="col-3 px-0" v-on:clickout="dropdownOpen = false">
          <div
            class="table-multi-select-dropdown"
            @click.stop="dropdownOpen = !dropdownOpen"
          >
            <div class="selected-options">
              <span>{{ $t("navigations.select columns") }}</span>
            </div>
            <div class="dropdown-arrow"></div>
          </div>
          <div v-if="dropdownOpen" class="table-dropdown-content" @click.stop>
            <label v-for="(column, index) in getColumns" :key="index">
              <input
                type="checkbox"
                v-model="selectedcolumnobj[column]"
                :value="true"
              />
              {{ column }}
            </label>
          </div>
        </div>
      </div>
      <template v-if="showTableLoader == true">
        <div class="text-center">
          <img
            src="../../assets/img/loading.gif"
            width="15"
            class=""
            alt="Waiting for login"
          />
          <div>
            {{ $t("navigations.please wait while the list is being loaded") }}
          </div>
        </div>
      </template>
      <template v-else>
        <div class="table-responsive custom-dark-table-wrapper">
          <table class="table table-striped dark-table-head mb-0">
            <thead>
              <tr>
                <th v-if="selectedcolumnobj['Signal ID']">Signal ID</th>
                <th v-if="selectedcolumnobj['Category']">Category</th>
                <th v-if="selectedcolumnobj['Technique']">Technique</th>
                <th v-if="selectedcolumnobj['Site Code']">Site Code</th>
                <th v-if="selectedcolumnobj['Level']">Level</th>
                <th v-if="selectedcolumnobj['Field Name']">Field Name</th>
                <th v-if="selectedcolumnobj['Observed Metric']">
                  Observed Metric
                </th>
                <th v-if="selectedcolumnobj['Benchmark Threshold']">
                  Benchmark Threshold
                </th>
                <th v-if="selectedcolumnobj['Outcome']">Outcome</th>
                <th v-if="selectedcolumnobj['SDV Required']">SDV Required</th>
                <th>Verify SDV</th>
                <th v-if="selectedcolumnobj['SDV Status']">SDV Status</th>
                <th v-if="selectedcolumnobj['SDV Outcome']">SDV Outcome</th>
                <th v-if="selectedcolumnobj['SDV Assigned']">SDV Assigned</th>
                <th v-if="selectedcolumnobj['Run Date']">Run Date</th>
                <th v-if="selectedcolumnobj['Run By']">Run By</th>
                <th>Assign SDV</th>
              </tr>
            </thead>
            <tbody class="custom-table-wrapper">
              <tr v-for="item in criticalDataPoints" :key="item.id">
                <td v-if="selectedcolumnobj['Signal ID']">
                  {{ item.signalId }}
                </td>
                <td v-if="selectedcolumnobj['Category']">
                  {{ item.catalogs?.[0]?.category }}
                </td>
                <td v-if="selectedcolumnobj['Technique']">
                  {{ item.catalogs?.[0]?.technique }}
                </td>
                <td v-if="selectedcolumnobj['Site Code']">
                  {{ item.siteCode }}
                </td>
                <td v-if="selectedcolumnobj['Level']">{{ item.level }}</td>
                <td v-if="selectedcolumnobj['Field Name']">
                  {{ item.fieldName }}
                </td>
                <td v-if="selectedcolumnobj['Observed Metric']">
                  {{ item.observedMetric }}
                </td>
                <td v-if="selectedcolumnobj['Benchmark Threshold']">
                  {{ item.benchmarkThreshold }}
                </td>
                <td v-if="selectedcolumnobj['Outcome']">{{ item.flagType }}</td>
                <td
                  v-if="selectedcolumnobj['SDV Required']"
                  :class="item.isSDV ? 'redclass' : 'greenclass'"
                >
                  {{ item.isSDV ? "Yes" : "No" }}
                </td>
                <td>
                  <button
                    v-if="!item.isSdvVerified"
                    class="btn btn-primary btn-sm py-0 py-0"
                    @click="verifySDV(item)"
                  >
                    Verify SDV
                  </button>
                </td>
                <td v-if="selectedcolumnobj['SDV Status']">
                  {{ item.isSdvVerified == true ? "Verified" : "Not Verified" }}
                </td>
                <td v-if="selectedcolumnobj['SDV Outcome']">
                  {{ item.sdvStatus }}
                </td>
                <td
                  v-if="selectedcolumnobj['SDV Assigned']"
                  :class="item.isSDVAssign ? 'redclass' : 'greenclass'"
                >
                  {{ item.isSDVAssign ? "Yes" : "No" }}
                </td>
                <td v-if="selectedcolumnobj['Run Date']">
                  {{ item.CreatedAt ? filter(item.CreatedAt) : "" }}
                </td>
                <td v-if="selectedcolumnobj['Run By']">{{ item.createdBy }}</td>
                <td>
                  <button
                    v-if="item.isSDV && item.sdvStatus == 'Confirmed' && !item.isSDVAssign" 
                    class="btn btn-primary btn-sm py-0"
                    @click="assignSDV(item.id)"
                  >
                    Assign SDV 
                  </button>
                </td>
              </tr>
              <!-- <td>{{ item.isSdvVerified == true ? 'Verified' : 'Not Verified' }}</td>

                <td>{{ item.sdvStatus }}</td>

                <td>{{ item.CreatedAt ? filter(item.CreatedAt) : "" }}</td>
                <td>{{ item.createdBy }}</td>
              </tr> -->
            </tbody>
          </table>
        </div>
      </template>
    </div>
  </div>

  <!-- <TaskListModal
    v-if="showCriricalPopUp"
    :criticalInfo="selectedCriticalDP"
    formPage="Task list data"
    @closeModal="closeCriticalDataPopup"
  /> -->
  <ChangesdvVerification
    v-if="showIsVerfySDVModal"
    :sdvId="selectedCriticalDP.id"
    @closeModal="closemodal"
  />
  <AssignSdvModal
    v-if="showIsAssignSDVModal"
    :signalid="selectedSignalId"
    @closeModal="closemodal"
  />

  <!-- <manageRiskRegisterModal
    v-if="showRiskRegisterModal"
    :riskRegId="riskRegisterId"
    @closeModal="closeRiskReg"
  /> -->
</template>

<script src="./dataSignal.js"></script>

<style scoped>
.custom-table-wrapper td{
  padding:2px 6px;
}
.custom-dark-table-wrapper {
  max-height: 400px;
  overflow-x: auto;
  overflow-y: auto;
}
.table {
  width: 100%;
  margin-bottom: 1rem;
  color: #212529;
  vertical-align: middle;
  border-color: #dee2e6;
}
.table-hover tbody tr:hover {
  background-color: rgba(209, 236, 255, 0.05);
}
.dark-table-head > thead {
  --bs-table-accent-bg: hsl(205, 72%, 37%) !important;
  color: #ffffff !important;
}
.dark-table-head thead th {
  position: sticky;
  top: 0;
  z-index: 1;
}
.redclass {
  background-color: #ffa500;
}
.greenclass {
  background-color: green;
}
</style>